import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

export const TeamCard = ({ className = '', team, index, onClick }) => (
    <div className={`team-card-container ${className}`} onClick={onClick}>
        <Link to={`/teams/${team._id}`}>
            <div className={`team-card`}>
                <div className={`team-header`}>
                    <p className={'team-name'}>{team.name}</p>
                </div>
                <div className={'team-description'}>{team.description}</div>
            </div>
        </Link>
    </div>
);

TeamCard.propTypes = {
    team: PropTypes.object,
    className: PropTypes.string,
    index: PropTypes.number,
    onClick: PropTypes.func
};

export default TeamCard;
